/*
 * @Description: 服务费明细列配置中间位（gysx）解析
 * @Date: 2026-09-14
 */
import { storeToRefs } from 'pinia';
import { IS_PLATFORM_TYPE_1_1 } from '@/config';
import appStore from '@/store';

/**
 * 详情页 getServiceCol 中间位
 * 服务商 + 向日葵 + 经营类 + 个体：按详情接口 serviceFeeAmountType 映射（1→1，2→0）；
 * 其它沿用列表传入的 gysx（工业是否虚拟）。
 */
export const resolveServiceColGysx = (
  serviceFeeAmountType: unknown,
  taxType: number,
  taxPattern: number | string,
  fallbackGysx: number
) => {
  const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
  const isAsp = defaultUserFnCode.value === 2;

  if (
    isAsp &&
    IS_PLATFORM_TYPE_1_1 &&
    taxType === 1 &&
    +taxPattern === 5 &&
    +serviceFeeAmountType
  ) {
    return +serviceFeeAmountType === 1 ? 1 : 0;
  }

  return fallbackGysx;
};
